import mergeURLSearchParams from './mergeURLSearchParams';

export default mergeURLSearchParams;
